import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// FIX ME
// remove materials lib from app
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { Overlay, CloseScrollStrategy } from '@angular/cdk/overlay';

// 3rd party
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { PlotlyViaCDNModule } from 'angular-plotly.js';

PlotlyViaCDNModule.setPlotlyVersion('latest');
PlotlyViaCDNModule.setPlotlyBundle('basic');

import { UiFeatureModule } from '@usimweb/ui/feature';
import { JwtInterceptor, ErrorInterceptor } from '@usimweb/core-auth';
import { CustomSerializer, reducers, effects } from '@usimweb/state/router-store';
import { CeetronModule } from '@usimweb/ceetron';

//store
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LetDirective, PushPipe } from '@ngrx/component';
import { ComponentStore } from '@ngrx/component-store';

// not used in production
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';

import { environment } from '../environments/environment';

import { UiSharedModule } from '@usimweb/ui/shared';
import { ResultComponent } from './feature/result/container/result/result.component';
import { ViewerInformationComponent } from './feature/result/components/viewer-information/viewer-information.component';
import { ResultsChartComponent } from './feature/result/components/results-chart/results-chart.component';
import { ReportComponent } from './feature/result/components/report/report.component';
import { ModelComponent } from './feature/result/components/model/model.component';
import { InputParametersComponent } from './feature/result/components/input-parameters/input-parameters.component';
import { MeasurementDataChartComponent } from './feature/result/components/measurement-data-chart/measurement-data-chart.component';
import { ViewerComponent } from './feature/viewer/container/viewer/viewer.component';
import { NewFoamingComponent } from './feature/new-foaming/container/newfoaming.component';
import { BoundaryPartComponent } from './feature/new-foaming/components/boundary-part/boundary-part/boundary-part.component';
import { MaterialComponent } from './feature/new-foaming/components/material/material.component';
import { OpenMoldComponent } from './feature/new-foaming/components/open-mold/open-mold/open-mold.component';
import { PartComponent } from './feature/new-foaming/components/part/part.component';
import { BoundaryConditionsComponent } from './feature/new-foaming/components/boundary-conditions/boundary-conditions.component';
import { ProcessDataComponent } from './feature/new-foaming/components/process-data/process-data.component';
import { SimulateComponent } from './feature/new-foaming/components/simulate/simulate.component';
import { CompareComponent } from './feature/compare/container/compare/compare.component';
import { InfoComponent } from './feature/compare/components/info/info.component';
import { MeasurementPlotComponent } from './feature/compare/components/measurement-plot/measurement-plot.component';
import { ParametersComponent } from './feature/compare/components/parameters/parameters.component';
import { ResultPlotComponent } from './feature/compare/components/result-plot/result-plot.component';

//dialogs
import { AddCadDialogComponent } from './dialogs/add-cad-dialog/add-cad-dialog.component';
import { CadDetailDialogComponent } from './dialogs/cad-detail-dialog/cad-detail-dialog.component';

import { MaterialDialogComponent } from './dialogs/material-dialog/material-dialog.component';
import { MoldClosingDialogComponent } from './dialogs/mold-closing-dialog/mold-closing-dialog.component';
import { OpenMoldDialogComponent } from './dialogs/open-mold-dialog/open-mold-dialog.component';
import { ProcessDialogComponent } from './dialogs/process-dialog/process-dialog.component';

import { AppTypePipe } from './dialogs/appType-pipe';
import { ProjectsPipe } from './dialogs/project-pipe';
import { FormsModule } from '@angular/forms';

export const metaReducers: MetaReducer<any>[] = !environment.production ? [storeFreeze] : [];

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@NgModule({ declarations: [
        AppComponent,
        ResultComponent,
        ViewerInformationComponent,
        ResultsChartComponent,
        ReportComponent,
        ModelComponent,
        MeasurementDataChartComponent,
        InputParametersComponent,
        ViewerComponent,
        NewFoamingComponent,
        BoundaryPartComponent,
        MaterialComponent,
        OpenMoldComponent,
        PartComponent,
        ProcessDataComponent,
        SimulateComponent,
        CompareComponent,
        InfoComponent,
        MeasurementPlotComponent,
        ParametersComponent,
        ResultPlotComponent,
        BoundaryConditionsComponent,
        //dialogs
        AddCadDialogComponent,
        CadDetailDialogComponent,
        MaterialDialogComponent,
        MoldClosingDialogComponent,
        OpenMoldDialogComponent,
        ProcessDialogComponent,
        //pipe todo add to shared lib
        AppTypePipe,
        ProjectsPipe,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        //RouterModule.forRoot(AppRoutingModule, { initialNavigation: 'enabledBlocking' }),
        UiFeatureModule,
        UiSharedModule,
        CeetronModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictStateSerializability: true,
                strictActionSerializability: true,
                strictActionWithinNgZone: true,
                strictActionTypeUniqueness: true,
            },
        }),
        EffectsModule.forRoot(effects),
        StoreDevtoolsModule.instrument({ connectInZone: true }),
        StoreRouterConnectingModule.forRoot({
            stateKey: 'routerReducer',
        }),
        LetDirective,
        PushPipe,
        FormsModule,
        //material
        MatSidenavModule,
        MatTabsModule,
        MatStepperModule,
        NgxSliderModule,
        PlotlyViaCDNModule], providers: [
        //Set app env for libs to know which app is currently build
        { provide: 'environment', useValue: environment },
        { provide: RouterStateSerializer, useClass: CustomSerializer },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        {
            provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: scrollFactory,
            deps: [Overlay],
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        ComponentStore,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
